export default __webpack_public_path__ + "static/media/landing3.76208f56.png";